jQuery(document).ready(function ($) {
  $('.wf-pmenu-category-links a[data-open-custom]').click(function (e) {
    if (localStorage.getItem('charleys_customer_store_location_name') && (localStorage.getItem('charleys_customer_deliverymode'))) {
      let readOnlyCategoryMenuItemCarryOver = $(this).find('strong').text();
      // if (readOnlyCategoryMenuItemCarryOver === "Charleys Wings") {
      //   readOnlyCategoryMenuItemCarryOver = 'wings';
      //   console.log('i wings');
      // }
      let readOnlyCategoryMenuItemCarryOverImg = $(this).find('img').attr('src');
      // console.log('sdgasdgadg', readOnlyCategoryMenuItemCarryOver);

      localStorage.setItem('readOnlyCategoryMenuItemCarryOver', readOnlyCategoryMenuItemCarryOver);
      localStorage.setItem('readOnlyCategoryMenuItemCarryOverImg', readOnlyCategoryMenuItemCarryOverImg);
      window.location.href = '/order/#menu';
    }
  });
  $('.food-item:not(.wf-pmenu-category-links) a[data-open-custom]').click(function (e) {
    e.preventDefault();

    console.log('open read-only menu PDP');
    $(".reveal-overlay").addClass('differnt-popup-overlay');

    // Title
    $('#food-modal [data-product-title]').text($(this).find('[data-title]').text());
    let titleText = $(this).find('[data-title]').text().toLowerCase().replace(/\s+/g, '-');
    $('#read-only-menu-start-order-button').attr('href', '/order/#menu-item-' + titleText);

    // Image
    $('#food-modal [data-product-image-heading]').css({
      'background-image': 'url(' + $(this).find('.image-container').attr('data-image') + ')'
    });
    $('#food-modal [data-product-image-heading] img').attr('src', $(this).find('.image-container').attr('data-image'));

    // Description
    $('#food-modal [data-product-description]').html(decodeURIComponent($(this).find('[data-description]').text().replace(/\+/g, ' ')));
 
    // Display calories
    var options = JSON.parse(decodeURIComponent($(this).attr('data-menu-options')));
    if (options.length > 0 && options[0].calories) {
      // Get the calories of the first object and remove '+cal'
      var firstCalories = options[0].calories.replace('+cal', '').trim();
      // Get the calories of the last object and remove '+cal'
      var lastCalories = options[options.length - 1].calories.replace('+cal', '').trim();

      // Combine the two values with a hyphen 
      var combinedCalories = firstCalories + '-' + lastCalories;

      // Set the value to the span[data-nutrition] as text
      $('span[data-nutrition="0"]').text(combinedCalories);
    } else {
      $('span[data-nutrition="0"]').addClass('hide');
      $('span[data-nutrition="0"]').parent().addClass('hide');
    }
    //click event to pass read only menu data
    let readOnlyMenuItemCarryOver = $(this).find('[data-title]').text();
    let readOnlyMenuItemCarryOverImg = $(this).find('.image-container').attr('data-image');

    $('#read-only-menu-start-order-button').click(function () {
      localStorage.setItem('readOnlyMenuItemCarryOver', readOnlyMenuItemCarryOver);
      localStorage.setItem('readOnlyMenuItemCarryOverImg', readOnlyMenuItemCarryOverImg);
    });

    $('#' + $(this).attr('data-open-custom')).foundation('open');

    if (!window.location.hash) {
      var urlReplace = "#" + $(this).attr('id');
      history.pushState(null, null, urlReplace);
    }

  });

  $(window).on('popstate', function () {
    if ($('#food-modal').attr('aria-hidden') == 'false') {
      $('#food-modal').foundation('close');
    }
  });

  $(document).on('closed.zf.reveal', '#food-modal[data-reveal]', function () {
    // console.log('reveal closed');
    if (window.location.hash && document.referrer !== '') {
      history.go(-1);
    }
    if (document.referrer == '') {      
      history.pushState(null, null, window.location.pathname);
    }
  });

  if (window.location.hash) {
    if ($('a' + window.location.hash).length) {
      $('a' + window.location.hash).click();
    }
  }

});
